var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPassword({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0705 0C4.4955 0 0 7 0 7C0 7 4.4955 14 12.0705 14C19.4955 14 24 7 24 7C24 7 19.4955 0 12.0705 0ZM12 2.1C14.925 2.1 17.25 4.27 17.25 7C17.25 9.73 14.925 11.9 12 11.9C9.075 11.9 6.75 9.73 6.75 7C6.75 4.27 9.075 2.1 12 2.1ZM12 4.2C10.35 4.2 9 5.46 9 7C9 8.54 10.35 9.8 12 9.8C13.65 9.8 15 8.54 15 7C15 6.58 14.9152 6.2342 14.7653 5.8842C14.5402 6.1642 14.2493 6.3 13.8743 6.3C13.2743 6.3 12.7493 5.81 12.7493 5.25C12.7493 4.9 12.8948 4.6284 13.1947 4.4184C12.8197 4.2784 12.4492 4.1993 11.9992 4.1993L12 4.2Z",
    fill: "#2E95B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.567662323e0738e3481be4ccf0334b94.svg";
export { ForwardRef as ReactComponent };